import { createContext } from "react";

const initialUserContext = {
  userDetails: null,
  setUserDetails: () => {},
};

export const UserContext = createContext(initialUserContext);

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;
